import {
  usePaginatedData,
} from "@/utils/vue_helpers";
import {
  stringNotEmpty,
  debounce,
} from "@/utils/functions";
import { computed, ref, watch } from "vue";
import { searchDebounceTimeInMs } from "@/utils/constants";
import apiCall from "@/utils/api";

/**
 * Composable for fetching scheme plan properties belonging to the authenticated client.
 * Supports debounced search and pagination.
 */
export function useFetchSchemePlanProperties() {
  const searchModel = ref("");
  const debouncedSearchModel = ref(null);

  const { paginationData: propertyData } = usePaginatedData();

  const url = computed(() => {
    let url = `/api/client/scheme-plan-property?page=${propertyData.paginationData.currentPage}`;

    if (stringNotEmpty(debouncedSearchModel.value)) {
      url += `&search=${debouncedSearchModel.value}`;
    }

    return url;
  });

  const setDebouncedSearch = debounce((searchValue) => {
    propertyData.setNewPage(1);
    debouncedSearchModel.value = searchValue;
  }, searchDebounceTimeInMs);

  watch(searchModel, (newVal) => {
    setDebouncedSearch(newVal);
  });

  watch(
    url,
    async (newUrl) => {
      propertyData.fetchData(newUrl);
    },
    { immediate: true }
  );

  function fetchProperties() {
    propertyData.fetchData(url.value);
  }

  return {
    propertyData,
    searchModel,
    fetchProperties,
  };
}

/**
 * Fetch form lookup data (sub-counties with wards/towns) for scheme plan properties.
 */
export async function fetchFormData() {
  try {
    const data = await apiCall({
      url: "/api/client/scheme-plan-property/form-data",
      method: "GET",
    });
    return data.subCounties || [];
  } catch (e) {
    console.error("Failed to load scheme plan form data", e);
    return [];
  }
}
